import { firestore } from 'firebase/app';
import DocumentSnapshot = firestore.DocumentSnapshot;
import FieldValue = firestore.FieldValue;
import { WebComment } from '@/web';
import { CommentMapper, FirestoreComment, DefaultPhotos, convertToPlainJsObject } from 'sparkello-core';

export class WebCommentMapper implements CommentMapper<DocumentSnapshot, FieldValue> {
  public mapToLocalComment(doc: DocumentSnapshot, parentId: string): WebComment {
    const comment = new WebComment(doc.id, parentId, doc.data()?.text);
    comment.authorUid = doc.data()?.authorUid;
    comment.authorName = doc.data()?.authorName;
    comment.authorProfileImage = doc.data()?.authorProfileImage
      || DefaultPhotos.getDefaultProfilePhotoForName(comment.authorName);
    console.log('Author Image', comment.authorProfileImage);
    comment.linkPreviewId = doc.data()?.linkPreviewId;
    comment.dateCreated = doc.data()?.dateCreated?.toDate();
    comment.lastUpdated = doc.data()?.lastUpdated?.toDate();

    return comment;
  }

  public mapToFirestoreComment(comment: WebComment): FirestoreComment<FieldValue> {
    const firestoreComment = {
      text: comment.text,
      authorName: comment?.authorName || '',
      authorUid: comment?.authorUid || '',
      authorProfileImage: comment?.authorProfileImage || '',
      linkPreviewId: comment?.linkPreviewId,
      dateCreated: comment?.dateCreated ? comment?.dateCreated : firestore.FieldValue.serverTimestamp(),
      lastUpdated: firestore.FieldValue.serverTimestamp(),
    };

    return convertToPlainJsObject(firestoreComment) as FirestoreComment<FieldValue>;
  }
}
